


export const ConfigReducer = (state, action) => {
   switch (action.type) {
    case 'setConfig':
        return {
            ...state,
            ...action.payload
        };
        break;
    case 'changeTheme':
        // cambiar la clase css al document del html
        console.log('action.payload', action.payload);
         document.documentElement.className = action.payload;
        return {
            ...state,
            theme: action.payload
        };
        break;

    case 'changeLanguage':
        return {
            ...state,
            language: action.payload
        };
        break;
   
    default:
        break;
   }
}